// Constants
import COLORS from "~constants/colors"

const optionBackground = state => {
  if (state.isSelected) {
    return COLORS.gray2
  }

  if (state.isFocused) {
    return COLORS.gray5
  }

  return "white"
}

export const customSelectStyles = {
  container: (provided, state) => {
    let style = provided

    if (state.className === "error") {
      style = {
        ...style,
        "div[class$='-control']": {
          borderBottomColor: `${COLORS.red} !important`,
        },
      }
    }
    if (state.isDisabled) {
      style = {
        ...style,
        "div[class$='-control']": {
          opacity: 0.5,
        },
      }
    }

    return style
  },
  control: (provided, state) => ({
    ...provided,
    border: "none",
    cursor: state.isDisabled ? "not-allowed" : "pointer",
    boxShadow: "none",
    borderRadius: "none",
    backgroundColor: "white",
    borderBottomWidth: "1px",
    borderBottomStyle: "solid",
    borderBottomColor: state.isFocused
      ? `${COLORS.caribbean} !important`
      : COLORS.gray2,
    ":hover": {
      borderBottomColor: COLORS.gray2,
    },
  }),
  indicatorsContainer: provided => ({
    ...provided,
    "div[class$='indicatorContainer']": {
      color: COLORS.gray4,
    },
  }),
  singleValue: provided => ({
    ...provided,
    color: COLORS.blue3,
  }),
  option: (provided, state) => ({
    ...provided,
    color: COLORS.blue3,
    cursor: "pointer",
    backgroundColor: optionBackground(state),
    ":hover": {
      backgroundColor: state.isSelected ? COLORS.gray2 : COLORS.gray5,
    },
  }),
}
